import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, modifyCallback, invalidDataCallback) => {

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      if (fieldName === 'calibratedPerformanceNineBox' || fieldName === 'calibratedPotentialNineBox') {
        return data[fieldName] === '0' ? '' : data[fieldName];
      }

      return data[fieldName];
    }

    const fieldNames = [
      'calibratedPerformanceNineBox',
      'calibratedPotentialNineBox',
      'calibrationCommittee',
      'calibrationComments',
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const schema = yup.object().shape({
      'calibratedPerformanceNineBox': yup.number().min(1).max(3).required(),
      'calibratedPotentialNineBox': yup.number().min(1).max(3).required(),
      'calibrationCommittee': yup.string().max(20),
      'calibrationComments': yup.string(),
    });
    return await schema.isValid(formData).then((valid) => valid);
  }

  const submit = async () => {
    if (await dataIsValid()) {
      let dataToSend = {
        ...formData,
        employeeCode: data.employeeCode,
      };

      modifyCallback(dataToSend);
      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: value,
    });
  }

  return { formData, setFormValue, submit };
}

export default useHandleForm;
